import { PropertyCardTemplate } from 'desktop/module/property/card/template';

/**
 * Property card template for desktop
 */
export const PropertyCardGetTemplate = () => PropertyCardTemplate;
